import React from 'react';
import { Modal, Typography, Space, Button } from 'antd';

const { Title, Paragraph, Text } = Typography;

interface TermsModalProps {
  visible: boolean;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ visible, onClose }) => {
  return (
    <Modal
      title={<Title level={3}>Algemene Voorwaarden RE-PACKED</Title>}
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose} style={{ backgroundColor: '#FF5d00', borderColor: '#FF5d00' }}>
          Sluiten
        </Button>
      ]}
      width={800}
    >
      <Typography>
        <Paragraph>
          <strong>Laatst bijgewerkt: 1 oktober 2022</strong>
        </Paragraph>

        <Title level={4}>Artikel 1 - Definities</Title>
        <Paragraph>
          In deze algemene voorwaarden wordt verstaan onder:
        </Paragraph>
        <Paragraph>
          1.1 <Text strong>RE-PACKED:</Text> de besloten vennootschap met beperkte aansprakelijkheid RE-PACKED, gevestigd en kantoorhoudende te Amsterdam, ingeschreven bij de Kamer van Koophandel onder nummer 12345678.
        </Paragraph>
        <Paragraph>
          1.2 <Text strong>Klant:</Text> de natuurlijke of rechtspersoon die met RE-PACKED een overeenkomst aangaat.
        </Paragraph>
        <Paragraph>
          1.3 <Text strong>Overeenkomst:</Text> de overeenkomst tussen RE-PACKED en Klant.
        </Paragraph>
        <Paragraph>
          1.4 <Text strong>Diensten:</Text> alle door RE-PACKED aan Klant geleverde diensten, zoals maar niet beperkt tot het aanbieden van verpakkingsoplossingen en logistieke diensten.
        </Paragraph>
        <Paragraph>
          1.5 <Text strong>Website:</Text> de website van RE-PACKED, te weten https://www.re-packed.com.
        </Paragraph>

        <Title level={4}>Artikel 2 - Toepasselijkheid</Title>
        <Paragraph>
          2.1 Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, offertes en overeenkomsten tussen RE-PACKED en Klant.
        </Paragraph>
        <Paragraph>
          2.2 Afwijkingen van deze algemene voorwaarden zijn slechts geldig indien deze uitdrukkelijk schriftelijk tussen partijen zijn overeengekomen.
        </Paragraph>
        <Paragraph>
          2.3 De toepasselijkheid van eventuele inkoop- of andere voorwaarden van Klant wordt uitdrukkelijk van de hand gewezen.
        </Paragraph>

        <Title level={4}>Artikel 3 - Aanbiedingen en offertes</Title>
        <Paragraph>
          3.1 Alle aanbiedingen en offertes van RE-PACKED zijn vrijblijvend, tenzij in het aanbod een termijn voor aanvaarding is genoemd.
        </Paragraph>
        <Paragraph>
          3.2 RE-PACKED kan niet aan zijn aanbiedingen en offertes worden gehouden indien Klant redelijkerwijs kan begrijpen dat de aanbiedingen of offertes, dan wel een onderdeel daarvan, een kennelijke vergissing of verschrijving bevat.
        </Paragraph>

        <Title level={4}>Artikel 4 - Overeenkomst</Title>
        <Paragraph>
          4.1 Een overeenkomst komt tot stand op het moment dat Klant een aanbieding of offerte van RE-PACKED aanvaardt.
        </Paragraph>
        <Paragraph>
          4.2 RE-PACKED heeft het recht bepaalde werkzaamheden te laten verrichten door derden.
        </Paragraph>

        <Title level={4}>Artikel 5 - Prijzen en betaling</Title>
        <Paragraph>
          5.1 Alle prijzen zijn in euro's en exclusief btw, tenzij anders vermeld.
        </Paragraph>
        <Paragraph>
          5.2 Betaling dient te geschieden binnen 14 dagen na factuurdatum, op een door RE-PACKED aan te geven wijze.
        </Paragraph>
        <Paragraph>
          5.3 Indien Klant in gebreke blijft in de tijdige betaling van een factuur, dan is Klant van rechtswege in verzuim. Klant is alsdan een rente verschuldigd van 1% per maand, tenzij de wettelijke rente hoger is, in welk geval de wettelijke rente verschuldigd is.
        </Paragraph>

        <Title level={4}>Artikel 6 - Levering</Title>
        <Paragraph>
          6.1 RE-PACKED zal de grootst mogelijke zorgvuldigheid in acht nemen bij het in ontvangst nemen en bij de uitvoering van bestellingen van producten en diensten.
        </Paragraph>
        <Paragraph>
          6.2 Als plaats van levering geldt het adres dat Klant aan RE-PACKED kenbaar heeft gemaakt.
        </Paragraph>

        <Title level={4}>Artikel 7 - Aansprakelijkheid</Title>
        <Paragraph>
          7.1 RE-PACKED is niet aansprakelijk voor schade, van welke aard ook, ontstaan doordat RE-PACKED is uitgegaan van door of namens Klant verstrekte onjuiste en/of onvolledige gegevens.
        </Paragraph>
        <Paragraph>
          7.2 RE-PACKED is uitsluitend aansprakelijk voor directe schade. Onder directe schade wordt uitsluitend verstaan de redelijke kosten ter vaststelling van de oorzaak en de omvang van de schade, de eventuele redelijke kosten gemaakt om de gebrekkige prestatie van RE-PACKED aan de overeenkomst te laten beantwoorden en redelijke kosten gemaakt ter voorkoming of beperking van schade.
        </Paragraph>

        <Title level={4}>Artikel 8 - Overmacht</Title>
        <Paragraph>
          8.1 RE-PACKED is niet gehouden tot het nakomen van enige verplichting jegens Klant indien hij daartoe gehinderd wordt als gevolg van een omstandigheid die niet is te wijten aan schuld, en noch krachtens de wet, een rechtshandeling of in het verkeer geldende opvattingen voor zijn rekening komt.
        </Paragraph>

        <Title level={4}>Artikel 9 - Intellectuele eigendom</Title>
        <Paragraph>
          9.1 Alle intellectuele eigendomsrechten met betrekking tot de door RE-PACKED geleverde diensten en producten berusten bij RE-PACKED of diens licentiegevers.
        </Paragraph>

        <Title level={4}>Artikel 10 - Toepasselijk recht en geschillen</Title>
        <Paragraph>
          10.1 Op alle rechtsbetrekkingen waarbij RE-PACKED partij is, is uitsluitend het Nederlands recht van toepassing.
        </Paragraph>
        <Paragraph>
          10.2 De rechter in de vestigingsplaats van RE-PACKED is bij uitsluiting bevoegd van geschillen kennis te nemen, tenzij de wet dwingend anders voorschrijft.
        </Paragraph>

        <Title level={4}>Artikel 11 - Wijziging voorwaarden</Title>
        <Paragraph>
          11.1 RE-PACKED is gerechtigd deze algemene voorwaarden te wijzigen of aan te vullen.
        </Paragraph>
        <Paragraph>
          11.2 Wijzigingen van ondergeschikt belang kunnen te allen tijde worden doorgevoerd.
        </Paragraph>
        <Paragraph>
          11.3 RE-PACKED zal Klant zo spoedig mogelijk op de hoogte stellen van substantiële wijzigingen van de algemene voorwaarden.
        </Paragraph>
      </Typography>
    </Modal>
  );
};

export default TermsModal; 